import { connect } from 'react-redux'
import { values } from 'lodash-es'
import { getTimeline } from '@selectors/data/timeline_selectors.js'
import { getMarkersForTimeline } from '@selectors/data/marker_selectors.js'
import { getTimespansForTimeline } from '@selectors/data/timespan_selectors.js'
import { getPhotos } from '@selectors/data/photo_selectors.js'
import { getShowAds, getAdChannel } from '@selectors/data/ad_selectors.js'
import Timeline from '../components/Timeline'

const mapStateToProps = (state, props) => {
  const { timelineId, environment } = props

  const showAds = getShowAds(state)
  const adChannel = getAdChannel(state)
  //const timeline = getTimeline(state, props, timelineId)
  const markers = values(getMarkersForTimeline(state, props, timelineId))
  const timespans = values(getTimespansForTimeline(state, props, timelineId))
  // TODO: Only pass in photos that are actually being used by markers
  const photos = getPhotos(state, props)

  return {
    markers,
    timespans,
    photos,
    showAds,
    adChannel,
    environment,
  }
}

const mapDispatchToProps = () => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(Timeline)
